<template>
  <div
    class="relative mb-16 flex h-full flex-col bg-[color:var(--color-header-bottom-bg)] md:max-h-[600px] md:flex-row lg:mb-24"
  >
    <VcImage v-if="ctaImage" :src="ctaImage" :alt="imageDescription" class="flex w-full object-cover md:w-1/2" lazy />

    <div class="w-full md:w-1/2">
      <div class="flex h-full flex-col justify-center p-8 md:p-12">
        <h2 v-if="title" class="mb-8 text-4xl font-semibold" :class="textColor ? textColor : 'text-white'">
          {{ title }}
        </h2>
        <div
          v-if="subtitle"
          class="heras-cta-text mb-6 text-lg"
          :class="textColor ? textColor : 'text-white'"
          v-html-safe="sanitizedSubtitle"
        ></div>
        <VcButton
          v-if="showTheButton"
          :to="buttonLink"
          variant="no-background"
          size="lg"
          color="white"
          append-icon="arrow-right"
          class="w-fit"
        >
          {{ buttonLabel }}
        </VcButton>
        <div v-if="buttons && buttons.length" class="flex w-full items-center justify-start space-x-6">
          <VcButton
            v-for="(item, index) in buttons"
            :key="index"
            v-bind="getLinkAttr(item.link)"
            class="w-1/2 px-8 lg:w-auto"
            color="secondary"
          >
            {{ item.label }}
          </VcButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";
import { marked } from "marked";
import DOMPurify from "dompurify";

type ButtonType = {
  label: string;
  link: string;
};

type ContentType = {
  html: string;
  markdown: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  ctaImage?: string;
  imageDescription?: string;
  title?: string;
  subtitle?: ContentType; // type markdown
  buttons?: Array<ButtonType>;
  buttonLink?: string;
  buttonLabel?: string;
}

const props = defineProps<IProps>();

const sanitizedSubtitle = computed(() =>
  DOMPurify.sanitize(marked(props.subtitle?.markdown || "") as string, { USE_PROFILES: { html: true } }),
);

const showTheButton = computed(() => {
  return Boolean(props.buttonLink) && Boolean(props.buttonLabel);
});
</script>

<style>
.heras-cta-text p {
  @apply font-light;
}
</style>
